<template>
    <div>
        <div class="head-container">
            <div>
                <div class="head-text-main">
                    TRAINING COURSES
                </div>
            </div>
        </div>
        <v-container class="main-text text-container">
            <v-row>
                <v-col>
                    <span class="green-text">NUTRISENSE PC</span> organizes special training seminars and workshops covering all aspects of greenhouse and open-field crop management in both soil- and soilless-cropping systems, which are available for everybody. Special seminars are offered for crop nutrition and fertilization in the horticultural sector, in both soil- and soilless-cropping systems. Participation to these seminars is open for both subscribers and non-subscribers of <span class="green-text">SOILLESS NutriSense</span> and <span class="green-text">SOIL NutriSense</span>.<br> Furthermore, <span class="green-text">NUTRISENSE PC</span> organizes special training seminars on optimal use of <span class="green-text">SOIL NutriSense</span> and/or <span class="green-text">SOILLESS NutriSense</span> which are available to both subscribers and non-subscribers who consider subscription to any of these versions of <span class="green-text">NutriSense</span> (but without any commitment to subscribe to <span class="green-text">NutriSense</span> if they participate to these seminars).
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    For further information, do not hesitate to contact us: <br>
                    Email: nutrisense@nutrisense.online <br>
                    Phone: <br> Panagiotis Kalozoumis: +30 698 286 3724 <br> Dimitrios Savvas: +30 694 589 3830
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.heading {
    color: #5FA936;
    font-size: 36px;
    font-weight: 700;
}

.head-container{
    background-image: url("~@/assets/about_a_head.png");
    min-height: 250px;
    height: auto;
    padding: 40px 20px;
    width: 100%;
    z-index: 0;
    color: #fff;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-shadow: 0px 0px 20px #0304036b;
    margin-top: -50px;
}

.head-text-main {
    font-weight: 700;
    font-size: clamp(28px, 7vw, 96px);
}

.head-text-secondary {
    font-size: 32px;
}

.main-text {
    color: #646464;
    font-size: 16px;
    line-height: 26px;
}
.text-container {
    max-width: 90%;
}

.green-text {
    color: #006600;
    font-weight: bold;
}

@media (max-width: 960px) {
    .head-container {
        min-height: 200px;
    }
}

@media (max-width: 600px) {
    .head-container {
        padding: 30px 15px;
        min-height: 150px;
    }
}
</style>
